import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  EXLY_WEBPAGE_DETAILS__FETCH_KEYWORDS,
  EXLY_WEBPAGE_DETAILS__REQUEST_LISTINGS,
  EXLY_WEBPAGE_DETAILS__SET_KEYWORDS,
  EXLY_WEBPAGE_DETAILS__SET_LISTINGS,
  EXLY_WEBPAGE_DETAILS__SET_SELECTED_KEYWORD,
  EXLY_WEBPAGE_DETAILS__SET_SAVE_CTA,
  EXLY_WEBPAGE_DETAILS__SET_KEYWORD_CATEGORY,
  EXLY_WEBPAGE_DETAILS__SET_PREPEND_PLAN,
  EXLY_WEBPAGE_DETAILS__SET_SAVED_REORDER_TYPE,
  EXLY_WEBPAGE_DETAILS__START_UPDATING,
  EXLY_WEBPAGE_DETAILS__STOP_PROCESSING,
} from "ui/pages/TemplatePreview/redux/actions";
import ExlyLoader from "ui/modules/ExlyLoader";
import { is_empty } from "utils/validations";
import module_style from "../Style.module.css";
import style from "../../../../../../../Style.module.css";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import UpdateName from "../Modals/UpdateName";
import dataProvider from "data/dataProvider";
import api from "data/APIs";
import { WebpageCreationContext } from "ui/pages/TemplatePreview";
import { is_desktop } from "utils/Utils";
import Backdrop from "@material-ui/core/Backdrop";
import { Checkbox, Modal } from "@material-ui/core";
import AccordianCard from "../Components/AccordianCard";
import AddKeywordListing from "../Components/AddKeywordListing";
import CreateKeyword from "../Components/CreateKeyword";
import { REORDERING } from "ui/pages/TemplatePreview/constants";
import RenderKeywordListing from "./RenderKeywordListing";
import AbsoluteLoader from "ui/modules/AbsoluteLoader";
import { useCustomizationStore } from "features/ManageWebpage/modules/Customizations/store/useCustomizationStore";
import { ReorderTabs } from "features/ManageWebpage/modules/Customizations/common/utils/Customization.constants";
import { logError } from "utils/error";

const KeywordType = () => {
  const dispatch = useDispatch();

  const keywords = useSelector((state) => state.webpage_detail.keywords);
  const keywords_fetched = useSelector(
    (state) => state.webpage_detail.keywords_fetched
  );
  const processing = useSelector((state) => state.webpage_detail.processing);
  const updating = useSelector((state) => state.webpage_detail.updating);
  const listings_data = useSelector((state) => state.webpage_detail.listings);
  const categorise_by_keyword = useSelector(
    (state) => state.webpage_detail.listings?.categorise_by_keyword
  );

  const { pushNotif } = React.useContext(WebpageCreationContext);

  const { setActiveReorderTab } = useCustomizationStore();

  React.useEffect(() => {
    dispatch({ type: EXLY_WEBPAGE_DETAILS__FETCH_KEYWORDS });
    dispatch({ type: EXLY_WEBPAGE_DETAILS__REQUEST_LISTINGS });

    setActiveReorderTab(ReorderTabs.CUSTOM);

    return () => setActiveReorderTab(null);
  }, []);

  const [add_keyword, set_add_keyword] = React.useState(false);
  const [add_keyword_listing, set_add_keyword_listing] = React.useState(false);
  const [edit_keyword_title, set_edit_keyword_title] = React.useState(false);

  React.useEffect(() => {
    // auto-open only once this screen's keywords fetch has completed -
    // keywords start as [] so emptiness is meaningless before that
    if (keywords_fetched && !processing && is_empty(keywords) && !add_keyword) {
      set_add_keyword(true);
    }
  }, [processing, keywords_fetched]);

  React.useEffect(() => {
    if ((add_keyword || add_keyword_listing) && !is_desktop) return;
    dispatch({
      type: EXLY_WEBPAGE_DETAILS__SET_SAVE_CTA,
      save_cta_text: "Save changes",
      handleSaveCta: handleSave,
    });
  }, [keywords, add_keyword_listing, add_keyword, listings_data]);

  const handleSave = async () => {
    if (is_empty(listings_data)) return;
    try {
      dispatch({ type: EXLY_WEBPAGE_DETAILS__START_UPDATING });
      let listings = listings_data.listings_data.listings.map((item) => {
        return {
          uuid: item.listing_id,
          priority: item.priority,
          heading: item.heading,
        };
      });
      if (!is_empty(listings))
        await dataProvider.custom_request(api.update_listing_priority, "POST", {
          listings: listings,
        });
      await dataProvider.custom_request(api.update_keyword_category, "POST", {
        categorise_by_keyword: listings_data.categorise_by_keyword,
      });

      let payload = keywords.map((item) => {
        return {
          uuid: item.uuid,
          sequence: item.sequence,
          keyword: item.keyword,
        };
      });

      await dataProvider.custom_request(api.update_keyword_priority, "POST", {
        keyword_sequences: payload,
      });

      if (!is_empty(listings_data.plans_data?.plans))
        await dataProvider.custom_request(api.update_prepend_plan, "POST", {
          prepend_plans: listings_data.prepend_plans,
        });

      let categorise_type = listings_data.categorise_by_keyword
        ? REORDERING.category_type.keyword_sku_listing_type
        : REORDERING.category_type.keyword_type;
      const update_status = await dataProvider.custom_request(
        api.update_listing_category,
        "POST",
        { categorise_type: categorise_type }
      );
      if (update_status.status === 200) {
        dispatch({
          type: EXLY_WEBPAGE_DETAILS__SET_SAVED_REORDER_TYPE,
          payload: categorise_type,
        });
        pushNotif(update_status.message);
        dispatch({ type: EXLY_WEBPAGE_DETAILS__STOP_PROCESSING });
      }
    } catch (err) {
      logError({
        error: err,
        occuredAt:
          "src/ui/pages/TemplatePreview/components/Sidebar/ListingReordering/KeywordType/index.js",
        when: "saving data",
      });
      pushNotif(
        err?.body?.message ? err?.body?.message : "Something went wrong"
      );
      dispatch({ type: EXLY_WEBPAGE_DETAILS__STOP_PROCESSING });
    }
  };

  const handleOnDragEnd = (result) => {
    if (
      is_empty(result.destination) ||
      (result.destination.droppableId === result.source.droppableId &&
        result.destination.index === result.source.index)
    ) {
      return;
    }

    if (result.type === "KEYWORD") {
      let output = keywords;
      const reorderedKeyword = output.splice(result.source.index, 1);
      output.splice(result.destination.index, 0, ...reorderedKeyword);

      for (let i = 0; i < output.length; i++) {
        let item = output[i];
        item.sequence = i + 1;
      }
      dispatch({ type: EXLY_WEBPAGE_DETAILS__SET_KEYWORDS, payload: output });
    } else {
      let output = listings_data;
      let listings = listings_data.listings_data.listings;
      let keyword_title = result.type.split("LISTINGS_")[1];
      let keyword_listings = listings.filter((listing) =>
        listing.keywords.includes(keyword_title)
      );
      const reordered_keyword_listings = keyword_listings.splice(
        result.source.index,
        1
      );
      keyword_listings.splice(
        result.destination.index,
        0,
        ...reordered_keyword_listings
      );
      for (let i = 0; i < keyword_listings.length; i++) {
        let item = keyword_listings[i];
        item.priority = keyword_listings.length - i;
        listings.filter((listing, index) => {
          if (listing.listing_id === item.listing_id) {
            listings.splice(index, 1);
          }
        });
      }
      listings.splice(listings.length, 0, ...keyword_listings);
      output.listings_data.listings = listings;
      dispatch({ type: EXLY_WEBPAGE_DETAILS__SET_LISTINGS, payload: output });
    }
  };

  const addKeywordLisitng = (keyword) => {
    dispatch({
      type: EXLY_WEBPAGE_DETAILS__SET_SELECTED_KEYWORD,
      payload: keyword,
    });
    set_add_keyword_listing(true);
  };

  if (!is_desktop && add_keyword)
    return (
      <CreateKeyword
        set_add_keyword={(value) => set_add_keyword(value)}
        add_keyword={add_keyword}
      />
    );

  if (add_keyword_listing && !is_desktop)
    return (
      <AddKeywordListing
        set_add_keyword_listing={(value) => set_add_keyword_listing(value)}
      />
    );

  return (
    <div className={`${module_style.container}`}>
      {updating && <AbsoluteLoader />}
      <div className={`${module_style.sub_heading} `}>
        Customize how offerings appear in your homepage
      </div>
      <div
        className={`${module_style.type_card_title} ${module_style.top_margin}`}
      >
        Create your custom keywords and Categorize based on them (Ex. Dance,
        Music, Yoga)
      </div>
      <div className=" top_margin">
        {processing || is_empty(listings_data) ? (
          <ExlyLoader />
        ) : (
          <div className={`pb-5`}>
            <DragDropContext onDragEnd={handleOnDragEnd}>
              <Droppable droppableId="keyword" type="KEYWORD" mode="standard">
                {(provided) => {
                  return (
                    <div ref={provided.innerRef}>
                      {keywords?.map((item, index) => {
                        return (
                          <Draggable
                            // eslint-disable-next-line react/no-array-index-key
                            key={`keyword-${index}`}
                            draggableId={`keyword-${index}`}
                            index={index}
                          >
                            {(provided) => (
                              <>
                                <div
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  className={` bottom_margin`}
                                >
                                  <AccordianCard
                                    item={item}
                                    title={item.keyword}
                                    provided={provided}
                                    handleEdit={() => {
                                      dispatch({
                                        type: EXLY_WEBPAGE_DETAILS__SET_SELECTED_KEYWORD,
                                        payload: item,
                                      });
                                      set_edit_keyword_title(true);
                                    }}
                                  >
                                    <RenderKeywordListing
                                      keyword={item}
                                      id={`keyword-${index}`}
                                      addKeywordLisitng={(keyword) =>
                                        addKeywordLisitng(keyword)
                                      }
                                    />
                                  </AccordianCard>
                                </div>
                                {provided.placeholder}
                              </>
                            )}
                          </Draggable>
                        );
                      })}
                      {provided.placeholder}
                    </div>
                  );
                }}
              </Droppable>
            </DragDropContext>
            <div
              className={`mt-3 row no-gutters`}
              style={{ alignItems: "center" }}
            >
              <Checkbox
                color="primary"
                checked={categorise_by_keyword}
                onChange={() => {
                  dispatch({
                    type: EXLY_WEBPAGE_DETAILS__SET_KEYWORD_CATEGORY,
                    payload: !categorise_by_keyword,
                  });
                }}
              />
              <div className={`${module_style.sub_heading} ml-2`}>
                Show listing type on card
              </div>
            </div>

            {!is_empty(listings_data?.plans_data?.plans) && (
              <div
                className={`mt-3 row no-gutters`}
                style={{ alignItems: "center" }}
              >
                <Checkbox
                  color="primary"
                  checked={listings_data?.prepend_plans}
                  onChange={(e) => {
                    dispatch({
                      type: EXLY_WEBPAGE_DETAILS__SET_PREPEND_PLAN,
                      payload: e.target.checked,
                    });
                  }}
                />
                <div className={`${module_style.sub_heading} ml-2`}>
                  Place plans above listings?
                </div>
              </div>
            )}

            <div
              onClick={() => set_add_keyword(true)}
              className={`mt-3 ${style.new_save_cta}`}
            >
              Manage keywords
            </div>
          </div>
        )}
      </div>
      {edit_keyword_title && (
        <UpdateName
          type={"keyword"}
          showModal={(value) => set_edit_keyword_title(value)}
        />
      )}

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={add_keyword_listing && is_desktop}
        onClose={() => {
          set_add_keyword_listing(false);
        }}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <div
          className={`alert_modal ${style.modal} ${module_style.overflowY_auto}`}
        >
          <AddKeywordListing
            set_add_keyword_listing={(value) => set_add_keyword_listing(value)}
          />
        </div>
      </Modal>

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={is_desktop && add_keyword}
        onClose={() => {
          set_add_keyword(false);
        }}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <div
          className={`alert_modal ${style.modal} ${module_style.overflowY_auto}`}
        >
          <CreateKeyword
            set_add_keyword={(value) => set_add_keyword(value)}
            add_keyword={add_keyword}
          />
        </div>
      </Modal>
    </div>
  );
};
export default KeywordType;
